import { render } from "./Detail.vue?vue&type=template&id=674f3d23&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=674f3d23&scoped=true&lang=css"

import exportComponent from "/var/www/ambientaly/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-674f3d23"]])

export default __exports__